export default __webpack_public_path__ + "static/media/solidario7.7389197e.jpeg";